import { render, staticRenderFns } from "./InsertEmail.vue?vue&type=template&id=09705360&"
import script from "./InsertEmail.vue?vue&type=script&lang=js&"
export * from "./InsertEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports